// extracted by mini-css-extract-plugin
export default {"card":"RedGradientCard_card__hO0PZ"};